import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

class HomeScopeController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.activateNext()
    this.initBgImagesAnimation()
  }
  addEventListeners() {
    super.addEventListeners()
    $('body').on('mouseenter', '.scope-list-box', $.proxy(this.onScopeMouseEnter, this))
    $('body').on('mouseleave', '.scope-list-box', $.proxy(this.onScopeMouseLeave, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    this.killBgImagesAnimation()
    $('body').off('mouseenter', '.scope-list-box', $.proxy(this.onScopeMouseEnter, this))
    $('body').off('mouseleave', '.scope-list-box', $.proxy(this.onScopeMouseLeave, this))
  }
  /**
   * OWN
   */
  initBgImagesAnimation() {
    // ticker FPS
    this._fps = 10
    this._fpsInterval = 1000 / this._fps
    this._then = Date.now()
    this._startTime = this._then
    this._stop = false
    // bg image
    this._changeTime = 5 // sec. 
    this._framesPerChange = this._changeTime * this._fps
    this._frameCount = 0
    
    // start
    window.requestAnimationFrame(this.onAnimationFrame.bind(this))
  }
  killBgImagesAnimation() {
    this._stop = true
  }

  onAnimationFrame() {
    if (!this._stop) {
      window.requestAnimationFrame(this.onAnimationFrame.bind(this))
    }
    const now = Date.now()
    const elapsed = now - this._then
    if (elapsed > this._fpsInterval) {
      this._then = now - (elapsed % this._fpsInterval)
      this.nextFrame()
    }
  }
  nextFrame() {
    this._frameCount++
    if (this._frameCount >= this._framesPerChange) {
      this._frameCount = 0
      this.activateNext()
    }
  }
  hideActive() {
    const activeList = [...document.querySelectorAll(".scope-list-home-illustr.active")]
    activeList.forEach((el) => {
      this.hideImages(el)
    })
  }
  activateNext() {
    this.hideActive()
    let next = document.querySelector(".scope-list-home-illustr.active + .scope-list-home-illustr")
    next = next ? next : document.querySelector(".scope-list-home-illustr")
    if (next) {
      this.showImages(next)
    }
  }
  activateById(id) {
    this.hideActive()
    const next = document.querySelector(".scope-list-home-illustr[data-scope-id='" + id + "']")
    if (next) {
      this.showImages(next)
    }
  }

  hideImages(wrapper) {
    const list = [...wrapper.querySelectorAll("img")]
    TweenMax.killTweensOf(list)
    TweenMax.to(list, .4, {opacity: 0, delay: (i) => i * .1, onComplete: () => {
      wrapper.classList.remove("active")
    }})
  }
  showImages(wrapper) {
    const list = [...wrapper.querySelectorAll("img")]
    TweenMax.killTweensOf(list)
    // reset opacity + randomize position
    const maxX = window.innerWidth * .1;
    const maxY = window.innerHeight * .1;
    list.forEach((img) => {
      const x = Math.random() * maxX - maxX * .5;
      const y = Math.random() * maxY - maxY * .5;
      TweenMax.set(img, { opacity: 0, x, y })
    })
    
    TweenMax.to(list, 1, {opacity: 1, delay: (i) => i * .1 + .4})
    wrapper.classList.add("active")
  }

  onScopeMouseEnter(e) {
    const trigger = e.currentTarget
    const id = trigger ? trigger.dataset.scopeId : null
    if (id) {
      this.activateById(id)
    }
    this.killBgImagesAnimation()
  }
  onScopeMouseLeave(e) {
    this.initBgImagesAnimation()
  }
  
  
}

export default HomeScopeController;